import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { menuItems } from "../Constants/menuItems";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const VarietyAccessories = () => {
    const [varieties, setVarieties] = useState([]);
    const [formData, setFormData] = useState({
        collectionName: "",
        category: "",
        routeTo: "",
        image: null,
        placeTo: "",

    });

    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const allPlaces = ["Place 1", "Place 2", "Place 3", "Place 4", "Place 5", "Place 6", "Place 7"];

    const placeImages = {
        "Place 1": "/images/place1.png",
        "Place 2": "/images/place2.png",
        "Place 3": "/images/place3.png",
        "Place 4": "/images/place4.png",
        "Place 5": "/images/place5.png",
        "Place 6": "/images/place6.png",
        "Place 7": "/images/place7.png"
    };

    const availablePlaces = varieties
    ? allPlaces.filter(
        (place) =>
            !varieties.some((variety) => variety.placeTo === place) ||
            place === formData.placeTo
    )
    : allPlaces;


    // Fetch all varieties
    useEffect(() => {
        fetchVarieties();
    }, []);

    const fetchVarieties = async () => {
        try {
            const response = await axios.get(`${backend_url}/api/variety`);
            setVarieties(response.data);
        } catch (error) {
            console.error("Error fetching varieties:", error);
        }
    };

    // Handle form input change
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image") {
            setFormData({ ...formData, image: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Handle category change and filter route options
    const handleCategoryChange = (e) => {
        const selected = e.target.value;
        setSelectedCategory(selected);
        setFormData({ ...formData, category: selected });

        if (selected) {
            const selectedCategory = menuItems.find((item) => item.value === selected);

            if (selectedCategory && selectedCategory.dropdown) {
                // Flatten dropdown and subcategories
                const options = selectedCategory.dropdown.flatMap((item) => {
                    if (item.value === null) {
                        return [
                            { label: `-- ${item.label} --`, value: null },
                            ...(item.subcategories || [])
                        ];
                    } else {
                        return item;
                    }
                });

                setCategoryOptions(options);
            } else {
                setCategoryOptions([]);
            }
        } else {
            setCategoryOptions([]);
        }
    };

    // Add or update variety
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!editingId && formData.image && formData.image.size > 1024 * 1024) {
            toast.error("Image size should not exceed 1 MB");
            return;
        }

        const data = new FormData();
        data.append("collectionName", formData.collectionName);
        data.append("routeTo", formData.routeTo);
        data.append("image", formData.image);
        data.append("placeTo", formData.placeTo);
        data.append("category", formData.category);

        try {
            if (editingId) {
                await axios.put(`${backend_url}/api/variety/${editingId}`, data);
                toast.success("Variety updated successfully");
            } else {
                await axios.post(`${backend_url}/api/variety`, data);
                toast.success("Variety added successfully");
            }
            fetchVarieties();
            closeModal();
        } catch (error) {
            console.error("Error saving variety:", error);
        }
    };

    // Handle edit
    const handleEdit = (variety) => {
        setFormData({
            collectionName: variety.collectionName,
            routeTo: variety.routeTo,
            image: variety.image,
            placeTo: variety.placeTo,
            category: variety.category,
        });
        setSelectedCategory(variety.category);

        // Populate the dropdown options correctly
        const selectedCategory = menuItems.find(
            (item) => item.value === variety.category
        );

        if (selectedCategory && selectedCategory.dropdown) {
            const options = selectedCategory.dropdown.flatMap((item) =>
                item.value === null
                    ? [
                        { label: `-- ${item.label} --`, value: null },
                        ...(item.subcategories || []),
                    ]
                    : item
            );
            setCategoryOptions(options);
        } else {
            setCategoryOptions([]);
        }

        setEditingId(variety._id);
        setShowModal(true);
    };

    // Handle delete
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this variety?")) {
            try {
                await axios.delete(`${backend_url}/api/variety/${id}`);
                fetchVarieties();
            } catch (error) {
                console.error("Error deleting variety:", error);
            }
        }
    };

    // Close modal and reset form
    const closeModal = () => {
        setShowModal(false);
        setEditingId(null);
        setFormData({ collectionName: "", routeTo: "", image: null, placeTo: "", category: "" });
        setSelectedCategory("");
        setCategoryOptions([]);
    };


    const formatText = (text) =>
        text.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

    return (
        <>
            <div className="variety-admin">
                <div className="headerSections">
                    <div className="head-title">Variety of Accessories</div>
                      {varieties.length < 8 && (
                    <button className="add-btn" onClick={() => setShowModal(true)} >
                        + Add Variety
                    </button>
                      )};
                </div>

                {/* Popup Modal */}
                {showModal && (
                    <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal" onClick={(e) => e.stopPropagation()}>
                            <h2>{editingId ? "Edit Variety" : "Add Variety"}</h2>
                            <form onSubmit={handleSubmit} className="variety-form">
                                <div className="form-group">
                                    <label htmlFor="collectionName">Collection Name</label>
                                    <input
                                        type="text"
                                        id="collectionName"
                                        name="collectionName"
                                        value={formData.collectionName}
                                        maxLength={30}
                                        onChange={handleChange}
                                        placeholder="Enter Collection Name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="category">Category</label>
                                    <select
                                        id="category"
                                        name="category"
                                        value={selectedCategory}
                                        onChange={handleCategoryChange}
                                        required
                                    >
                                        <option value="">Select a category</option>
                                        {menuItems.map((category) => (
                                            <option key={category.value} value={category.value}>
                                                {category.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Route To Dropdown */}
                                <div className="form-group">
                                    <label htmlFor="routeTo">Route To</label>
                                    <select
                                        id="routeTo"
                                        name="routeTo"
                                        value={formData.routeTo}
                                        onChange={handleChange}
                                        required
                                        disabled={!selectedCategory}
                                    >
                                        <option value="">Select a route</option>
                                        {categoryOptions.map((option) =>
                                            option.value ? (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ) : (
                                                <option key={option.label} value="" disabled>
                                                    {option.label}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="image">Image</label>
                                    <input
                                        type="file"
                                        id="image"
                                        name="image"
                                        onChange={handleChange}
                                        accept="image/*"
                                        required={!editingId}
                                        style={{ display: "none" }} // Hide actual file input
                                    />
                                    <input
                                        type="text"
                                        value={
                                            formData.image
                                                ? formData.image.name || formData.image
                                                : varieties.find(p => p._id === editingId)?.image.split('/').pop() || ""
                                        }
                                        placeholder={
                                            formData.image || editingId
                                                ? "Image already uploaded"
                                                : "Choose the image"
                                        }
                                        onClick={() => document.getElementById("image").click()}
                                        readOnly
                                    />
                                </div>

                                {/* <div className="form-group">
                                <label htmlFor="placeTo">Place To</label>
                                <select
                                    id="placeTo"
                                    name="placeTo"
                                    value={formData.placeTo}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select a place</option>
                                    {availablePlaces.map((place) => (
                                        <option key={place} value={place}>
                                            {place}
                                        </option>
                                    ))}
                                </select>
                            </div> */}

                                <div className="form-group">
                                    <label htmlFor="placeTo">Place To</label>
                                    <select
                                        id="placeTo"
                                        name="placeTo"
                                        value={formData.placeTo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a place</option>
                                        {availablePlaces.map((place) => (
                                            <option key={place} value={place}>
                                                {place}
                                            </option>
                                        ))}
                                    </select>
                                    {formData.placeTo && (
                                        <div className="place-preview">
                                            <img
                                                src={placeImages[formData.placeTo]}
                                                alt={formData.placeTo}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="form-buttons">
                                    <button type="submit" className="submit-btn">
                                        {editingId ? "Update" : "Add"}
                                    </button>
                                    <button type="button" onClick={closeModal} className="cancel-btn">
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* List Table */}
                <table className="variety-table">
                    <thead>
                        <tr>
                            <th>Collection Name</th>
                            <th>Category</th>
                            <th>Route To</th>
                            <th>Image</th>
                            <th>Place To</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {varieties.map((variety) => (
                            <tr key={variety._id}>
                                <td>{variety.collectionName}</td>
                                <td>{formatText(variety.category)}</td>
                                <td>{formatText(variety.routeTo)}</td>
                                <td>
                                    <img src={`${variety.image}`} alt={variety.collectionName} />
                                </td>
                                <td>{variety.placeTo}</td>
                                <td>
                                    <button onClick={() => handleEdit(variety)}>Edit</button>
                                    {/* <button onClick={() => handleDelete(variety._id)}>Delete</button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <ToastContainer />
        </>
    );
};

export default VarietyAccessories;
